export class PlanGroup {
  identifier: string;
  items: PlanGroupItem[];
  useOdontogram: boolean;

  constructor(identifier: string, useOdontogram: boolean = true) {
    this.identifier = identifier;
    this.items = [];
    this.useOdontogram = useOdontogram;
  }
}

export class PlanGroupItem {
  identifier: string;
  components?: string[];
  mainComponent?: string;
  selectionMode?: string;
  custom?: PlanGroupItemCustom;

  constructor(
    identifier: string,
    components: string[] = [],
    mainComponent: string = "odontogram",
    selectionMode: string = "single",
    custom: PlanGroupItemCustom = null,
  ) {
    this.identifier = identifier;
    this.components = components;
    this.mainComponent = mainComponent;
    this.selectionMode = selectionMode;
    this.custom = custom;
  }
}
export class PlanGroupItemCustom {
  id: number;
  name: string;
  parent: string;
  price?: number;

  constructor(id: number, name: string, parent: string, price?: number) {
    this.id = id;
    this.name = name;
    this.parent = parent;
    this.price = price;
  }
}

export class PlanStage {
  id?: number;
  name: string;
  description?: string;
  customSubtotalText?: string;
  discount?: Discount;
  items: PlanItem[];

  constructor(
    name: string,
    description: string,
    customSubtotalText?: string,
    discount?: Discount,
  ) {
    this.name = name;
    this.description = description;
    this.customSubtotalText = customSubtotalText;
    this.discount = discount;
    this.items = [];
  }
}

export class PlanItem {
  id?: number;
  treatment: string;
  options: any; // ItemOptions;
  observations?: string;
  teeth: number[];
  valid?: boolean;
  price?: number;
  date?: Date;
  optional?: boolean;
  stage?: number;
  customTreatmentId?: number;
  customTreatmentPrice?: number;
  name?: string;

  constructor() {
    this.treatment = "";
    this.observations = "";
    this.teeth = [];
    this.options = new ItemOptions();
    this.valid = false;
    this.customTreatmentId = null;
    this.customTreatmentPrice = null;
    this.name = null;
    this.optional = false;
  }
}

export class ItemOptions {
  channels?: number;
  surfaces?: string[];
  options?: string[];
  name?: string;
  type?: string;

  constructor() {
    this.channels = null;
    this.surfaces = [];
    this.options = [];
    this.name = null;
    this.type = null;
  }
}

export class ToothPlan {
  treatment: string;
  options?: string;
}

export class EdentulousOptions {
  arch?: string;
  type?: string;
  material?: string;
  mode?: string;
  implants?: number;

  constructor() {
    this.type = "fixed_bridge";
    this.material = "ceramic";
    this.mode = "vertical";
    this.implants = 4;
  }
}

export class Discount {
  name: string;
  type: string;
  value: number;

  constructor() {
    this.name = "";
    this.type = "percentage";
    this.value = 0;
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/plan.model.ts